<!-- order table显示列的定制 -->
<template>
<el-popover
    placement="bottom"
    width="160"
    v-model="visible"
>
    <div>
        <div>
            <el-checkbox-group v-model="selecteds">
                <draggable v-model="columns">
                    <transition-group>
                        <el-checkbox style="display:block;" v-for="col in columns" :label="col.field" :key="col.field">{{col.title}}</el-checkbox>
                    </transition-group>
                </draggable>
            </el-checkbox-group>
            <div style="margin-top: 10px; font-size:12px; margin-bottom:10px; color: red;">
                注：勾选后拖动可排序
            </div>
        </div>
        <div style="border-top: 1px #DCDFE6 solid; margin: 8px 0px;"></div>
        <div style="text-align:right; ">
            <el-link type="primary" @click="selectAll">全选</el-link>
            <el-link type="primary" style="margin-left: 8px; margin-right: 8px;"  @click="reset">重置</el-link>
            <el-button size="mini" round type="primary" @click="enter">确定</el-button>
        </div>
    </div>
    <el-link slot="reference" :underline="false">
        <div class="wrap" >
            <i class="iconfont icon-guolvqi font22"></i>
            <span class="txt">{{msg('页面布局')}}</span>
        </div>
    </el-link>
</el-popover>

</template>

<script>

import draggable from 'vuedraggable'

/*
{key: 1, key:0}
*/

export default {
    name: "ColumnSettings",
    components:{
        draggable: draggable,
    },
    data(){
        return {
            originColumns:[],
            columns: [],
            selecteds: [],
            visible: false,
        }
    },
    props: {
        colKey: String,
        allColumns: Array
    },
    mounted(){
       this.init();
    },
    methods: {
        async init(){
            this.allColumns.forEach(c => {
                this.originColumns.push(c);
            })

            this.selecteds = [];
            let savedColumnResult = await this.$axios.get(this.$kit.api.user.configs+"?groups="+this.colKey);
            if(savedColumnResult && savedColumnResult.data[this.colKey]){
                let savedColumns = JSON.parse(savedColumnResult.data[this.colKey][0].xvalue);
                if(savedColumns){
                    for(let key in savedColumns){ //{key: 1, key:0}
                        let checked = savedColumns[key] ? true: false;
                        let col = this.allColumns.find(i => i.field == key);
                        if(col){
                            if(checked){
                                this.selecteds.push(col.field);
                            }
                            this.columns.push(col);
                        }
                    }
                }
            }
            
            if(this.columns.length==0){
                this.allColumns.forEach(c => {
                    this.columns.push(c);
                })
            }
        },
        reset(){
            this.selecteds = [];
            this.columns = [];

            //清空设置
            this.$axios.get(this.$kit.api.user.deleteConfigByKey+"?key="+this.colKey);

            this.originColumns.forEach(c => {
                this.columns.push(c);
            })
            
        },
        enter(){
            let cols = [];
            if(this.selecteds && this.selecteds.length>0){

                let paramCols = {};
                this.columns.forEach(item => {
                    let checkedIndex = this.selecteds.findIndex(s => s == item.field);
                    let checked = checkedIndex>-1?1:0;
                    paramCols[item.field] = checked;
                    if(checked){
                        cols.push(item);
                    }
                })

                //保存设置
                // localStorage.setItem(COL_KEY, cols.join(","));
                this.$axios.get(this.$kit.api.user.saveOrUpdateConfigByKey+"?key="+this.colKey+"&value="+encodeURIComponent(JSON.stringify(paramCols)));
            }else{
                cols = this.columns;
                //删除设置
                // localStorage.removeItem(COL_KEY);
                this.$axios.get(this.$kit.api.user.deleteConfigByKey+"?key="+this.colKey);
            }

            this.visible = false;
            this.$emit("refresh-column", cols);

        },
        selectAll(){
            if(this.selecteds.length == this.columns.length){
                this.selecteds = [];
            }else{
                this.selecteds = this.columns.map(c => c.field);
            }
        },
        sortCols(cols){
            
            let newCols = [];

            this.columns.forEach(col => {
                let field = cols.find(f => f == col.field);
                if(field){
                    newCols.push(field);
                }
            })

            return newCols;

        }
    }

}

</script>